"use client";
import { Nft } from "@/api/nfts/types";
import { OfferOrder } from "@/api/orders/types";

import { isExpiredInSeconds } from "@/shared/dates";
import useMe from "@/shared/hooks/useMe";
import { isEqual } from "@/shared/string";
import { useMemo } from "react";
import { AcceptOfferButton } from "../AcceptOffer";
import { CancelOfferButton } from "../CancelOffer";

export interface Props {
  nft?: Nft;
  offer: OfferOrder;
}

export default function OfferActionButton({ nft, offer }: Props) {
  const isExpired = useMemo(
    () => isExpiredInSeconds(offer.expiresAt),
    [offer.expiresAt],
  );

  const { me } = useMe();

  if (!me) return null;

  return (
    <>
      {isEqual(offer.buyer, me.address) ? (
        <CancelOfferButton
          offer={{ ...offer, nft }}
          collection={offer.NftContract}
        />
      ) : isEqual(nft?.owner.address, me.address) && !isExpired ? (
        <AcceptOfferButton offer={{ ...offer, nft }} />
      ) : null}
    </>
  );
}
